export default __webpack_public_path__ + "static/media/norlys-og-standard.7c967368.png";